import { ListProps, TextField } from 'react-admin';

import { TextInput, Grid, GridList, DateField, Forbidden } from '@components';
import { useRbacList } from '@hooks';

export const PermissionList = (props: ListProps) => {
  const rbacList = useRbacList();

  if (!rbacList) {
    return <Forbidden />;
  }

  return (
    <GridList {...props}
      filters={Filters}
      sort={{ field: 'categoryId', order: 'ASC' }}
    >
      <Grid
        rowClick="edit"
        defaultColumns={'id name method path module createdAt'.split(' ')}
      >
        <TextField source="id" label="ID" />
        <TextField source="name" label="Name" />
        <TextField source="method" label="Method" />
        <TextField source="path" label="Path" />
        <TextField source="module" label="Module" />
        <DateField source="createdAt" showTime label="Created at" />
      </Grid>
    </GridList>
  );
};

const Filters = [
  <TextInput source="q" key="q" variant="outlined" label="Search" alwaysOn />,
];
